<template>
  <div id="app" class="download-page">
    <HeadNav
      selected-language="en"
      page="download"
      :gotodownload="gotodownload"
    />

    <main class="download-main">
      <section class="download-hero">
        <p class="security-marker">
          <i class="fa fa-shield-alt" aria-hidden="true"></i>
          Security Verified
        </p>
        <h1>Get GB WhatsApp APK for Android</h1>
        <a href="/" class="download-hero-home" :title="site.siteName" rel="home">
          <img
            class="download-hero-logo"
            src="@/assets/gbwa-logo.webp"
            alt="GB WhatsApp APK download logo"
          >
        </a>
        <p>
          Enter this page to download <a href="/">GB WhatsApp APK</a> Safely. You should enable install unknown Apps before install GBWhatsApp.
        </p>
        <a class="primary-download" :href="site.apkUrl">
          <i class="fa fa-cloud-download-alt" aria-hidden="true"></i>
          Download GB WhatsApp APK
        </a>
      </section>

      <section class="download-section">
        <h2>Before You Install GB WhatsApp APK on Android</h2>
        <ul class="guide-dot-list">
          <li v-for="tip in beforeInstall" :key="tip">{{ tip }}</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import site from '@/config/site.json';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  data() {
    return {
      site,
      beforeInstall: [
        'Back up your chats before updating or switching versions.',
        'Download the latest available APK instead of using outdated releases.',
        'Make sure your device has enough free storage before installing.',
        'Allow Install Unknown Apps only for the browser or file manager you are using.',
        'If you are updating an existing installation, install the new APK over the current version whenever possible.',
      ],
    };
  },
  methods: {
    gotodownload() {
      if (typeof window !== 'undefined') {
        window.location.href = this.site.apkUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.download-page {
  min-height: 100vh;
  background: #f6f8fb;
}

.download-main {
  width: min(980px, calc(100% - 30px));
  margin: 0 auto;
  padding: 28px 0 60px;
}

.download-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  padding: 40px 32px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(31, 53, 86, 0.06);
  text-align: center;
}

.security-marker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 7px 14px 7px 12px;
  border: 1px solid #cce8d8;
  border-radius: 999px;
  background: #f6fbf8;
  color: #0b6d47;
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
}

.security-marker .fa {
  color: #0b6d47;
}

.download-hero h1 {
  margin: 0;
  max-width: 18em;
  color: #14213d;
  font-size: clamp(30px, 5vw, 44px);
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.download-hero p:not(.security-marker) {
  margin: 0;
  max-width: 36em;
  color: #3c4b62;
  font-size: 16px;
  line-height: 1.7;
}

.download-hero p a {
  color: #0b6d47;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.download-hero p a:hover,
.download-hero p a:focus,
.download-hero p a:active {
  color: #0a5f3e !important;
}

.download-hero-home {
  display: block;
  line-height: 0;
}

.download-hero-logo {
  display: block;
  width: min(160px, 36vw);
  height: auto;
  object-fit: contain;
}

.primary-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 260px;
  min-height: 54px;
  padding: 14px 28px;
  border-radius: 8px;
  background: #0b6d47;
  color: #fff !important;
  font-size: 17px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 8px 24px rgba(11, 109, 71, 0.22);
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.primary-download .fa {
  font-size: 1.05em;
}

.primary-download:hover,
.primary-download:focus {
  background: #0a5f3e;
  color: #fff !important;
  box-shadow: 0 10px 28px rgba(11, 109, 71, 0.28);
}

.download-section {
  margin-top: 22px;
  padding: 30px 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(31, 53, 86, 0.06);
}

.download-section h2 {
  margin: 0 0 18px;
  color: #14213d;
  font-size: 28px;
  line-height: 1.25;
  letter-spacing: 0;
}

.guide-dot-list {
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

.guide-dot-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding-left: 0;
  list-style: none !important;
  color: #3c4b62;
  font-size: 16px;
  line-height: 1.7;
}

.guide-dot-list li::before {
  flex: 0 0 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2563eb;
  content: '';
}

.guide-dot-list li::marker {
  content: '';
}

.guide-dot-list li:last-child {
  margin-bottom: 0;
}

@media (max-width: 640px) {
  .download-main {
    width: min(100% - 20px, 980px);
    padding-top: 10px;
  }

  .download-hero,
  .download-section {
    padding: 28px 20px;
  }

  .download-hero {
    gap: 18px;
  }

  .download-hero h1 {
    font-size: 28px;
  }

  .primary-download {
    width: 100%;
    max-width: 320px;
  }
}
</style>
